import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Fab, Tooltip } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  root: ({ color }) => ({
    backgroundColor:
      color === 'positive'
        ? theme.palette.green['500']
        : theme.palette.secondary.main,
    width: '48px',
    height: '48px',
    '&:hover': {
      backgroundColor:
        color === 'positive'
          ? theme.palette.green['300']
          : theme.palette.primary.main,
    },
  }),
  postIcon: () => ({
    width: '20px',
  }),
}))

const ImageIconButton = ({ src, className, title, ...props }) => {
  const color = props.color || 'primary'
  const classes = useStyles({ color })
  return (
    <Tooltip title={title} placement="bottom">
      <Fab color="primary" className={clsx(classes.root, className)} {...props}>
        <img className={classes.postIcon} src={src} alt="ImageIconButton" />
      </Fab>
    </Tooltip>
  )
}

ImageIconButton.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
}

export default ImageIconButton
